import _typeof from "@babel/runtime/helpers/typeof";
export function logger(data) {
  if (!logger.on) return;
  logger.engine(data);
}
logger.on = false;
logger.engine = function (data) {
  var name = data.name,
    type = data.type,
    state = data.state,
    request = data.request,
    response = data.response,
    stage = data.stage;
  console[type]([name, stage, state, request, response].filter(Boolean).map(function (v) {
    return _typeof(v) === 'object' ? JSON.stringify(v) : v;
  }).join('; '));
};